import type {
  JobRecommendationFragment,
  JobTeaserVisibleJobFragment,
} from '@xing-com/crate-jobs-graphql';
import {
  InViewTracking,
  useJobsNwtTracking,
} from '@xing-com/crate-jobs-tracking';
import { JobTeaserCard } from '@xing-com/crate-jobs-xinglets';

type JobRecommendationProps = {
  recommendation: JobRecommendationFragment;
  index: number;
};

export const Recommendation: React.FC<JobRecommendationProps> = ({
  recommendation,
  index,
}) => {
  const { job, position, trackingToken } = recommendation;
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const visibleJob = job as JobTeaserVisibleJobFragment;
  const trackNwt = useJobsNwtTracking();
  const trackingProps = {
    eventSchema: 'basic' as const,
    trackingToken,
    position: index,
    originalPosition: position,
    page: 'jobs/empty_state_job_expired',
    itemUrn: visibleJob.globalId,
  };
  const handleOnClick = (): void => {
    trackNwt({
      event: 'opened',
      ...trackingProps,
    });
  };

  return (
    <InViewTracking
      nwtTrackingOptions={{
        event: 'entered_viewport',
        ...trackingProps,
      }}
    >
      <JobTeaserCard
        job={visibleJob}
        url={`${visibleJob.url}?ijt=jb_75`}
        matchingHighlights={recommendation.matchingHighlightsV2}
        headingLevel="h2"
        data-testid="job-recommendation-card"
        aria-label={visibleJob.title}
        nwtTrackingOptionsBookmarkToggle={trackingProps}
        onClick={handleOnClick}
      />
    </InViewTracking>
  );
};
